/**
 * FortuneReport - iAngelFace
 * Main application logic
 */

// --- Product Database (Dynamic from Shopify or Local Fallback) ---
let products = [];

if (window.SHOPIFY_FORTUNE_PRODUCTS && window.SHOPIFY_FORTUNE_PRODUCTS.length > 0) {
  // Map Shopify data to our app structure
  products = window.SHOPIFY_FORTUNE_PRODUCTS.map(p => ({
    id: p.id || p.handle,
    title: p.title,
    price: p.price, 
    url: "/products/" + p.handle, // Local relative URL works better in shopify
    image: p.image,
    // Convert shopify tags to lowercase for matching
    tags: p.tags ? p.tags.map(t => t.toLowerCase()) : ['energy'],
    cssClass: `p-${p.tags && p.tags[0] ? p.tags[0].toLowerCase() : 'energy'}`
  }));
} else {
  // Fallback data for local development testing
  products = [
    {
      id: "p1",
      title: "925 Sterling Silver Luck Koi Fish Braided Bracelet",
      price: "$25.90",
      url: "https://iangelface.com/products/925-sterling-silver-luck-koi-fish-braided-bracelet",
      image: "https://cdn.shopify.com/s/files/1/0806/8225/4586/files/3-tuya_72df642c-b93f-4e8d-94ac-8f2b63e992b4.jpg?v=1767780211",
      tags: ["wealth", "career"],
      cssClass: "p-wealth"
    },
    {
      id: "p2",
      title: "Feng Shui Pixiu Green Jade Bracelet — Wealth & Protection",
      price: "$39.90",
      url: "https://iangelface.com/products/fengshui-pixiu-jade-protection-bracelet",
      image: "https://cdn.shopify.com/s/files/1/0806/8225/4586/files/1-tuya_37d3570c-a46a-482b-a2d3-a8bd3acc4eaa.jpg?v=1767786421",
      tags: ["wealth", "energy"],
      cssClass: "p-wealth"
    },
    {
      id: "p3",
      title: "iAngelFace™ | The Abundance Seal - Sacred Geometry Tech Talisman",
      price: "$39.90",
      url: "https://iangelface.com/products/iangelface%E2%84%A2-the-abundance-seal-sacred-geometry-tech-talisman",
      image: "https://cdn.shopify.com/s/files/1/0806/8225/4586/files/3_85c627f6-440b-48de-a2c9-6f2defb543d6.jpg?v=1778740221",
      tags: ["wealth", "career", "energy"],
      cssClass: "p-career"
    },
    {
      id: "p4",
      title: "iAngelFace™ | The Sacred Abundance Treasury - Premium Handcrafted Wood Manifestation Frame",
      price: "$59.90",
      url: "https://iangelface.com/products/iangelface%E2%84%A2-the-sacred-abundance-treasury-premium-handcrafted-wood-manifestation-frame",
      image: "https://cdn.shopify.com/s/files/1/0806/8225/4586/files/3_1c775f91-9ee2-4c82-b93c-8dbb13ac00fc.jpg?v=1778743062",
      tags: ["wealth", "career"],
      cssClass: "p-wealth"
    },
    {
      id: "p5",
      title: "Natural Rainbow Obsidian Positive Transformation Bracelet",
      price: "$26.90",
      url: "https://iangelface.com/products/natural-rainbow-obsidian-positive-transformation-bracelet",
      image: "https://cdn.shopify.com/s/files/1/0806/8225/4586/files/1_5ce56965-eab9-4fc5-94fe-5738fd19bfa8.jpg?v=1767841167",
      tags: ["energy", "health", "love"],
      cssClass: "p-energy"
    },
    {
      id: "p6",
      title: "Natural White Jade Koi Lucky Necklace",
      price: "$25.90",
      url: "https://iangelface.com/products/natural-white-jade-koi-lucky-necklace",
      image: "https://cdn.shopify.com/s/files/1/0806/8225/4586/files/3-tuya.jpg?v=1767778230",
      tags: ["love", "health"],
      cssClass: "p-love"
    },
    {
      id: "p7",
      title: "Sterling Silver Pixiu Ring — Wealth Attraction & Prosperity Guard",
      price: "$59.90",
      url: "https://iangelface.com/products/mens-ring-original-feng-shui-pixiu-mani-mantra-protection-wealth-charms-amulet-lucky-open-adjustable-ring-buddhist-jewelry",
      image: "https://cdn.shopify.com/s/files/1/0806/8225/4586/files/1_846f637c-528b-498f-bf8e-0beae3ef3e54.jpg?v=1767799254",
      tags: ["wealth", "protection"],
      cssClass: "p-wealth"
    },
    {
      id: "p8",
      title: "Year of the Horse Bamboo Dragon Lotus Phoenix Plush Doll",
      price: "$25.90",
      url: "https://iangelface.com/products/year-of-the-horse-bamboo-dragon-lotus-phoenix-plush-doll-home-decoration",
      image: "https://cdn.shopify.com/s/files/1/0806/8225/4586/files/3_ce980187-7614-483a-a211-b3b2811a1fc5.webp?v=1767663253",
      tags: ["energy", "home"],
      cssClass: "p-energy"
    },
    {
      id: "p9",
      title: "🐎Year of the Horse 999 Sterling Silver String Braided Protection Bracelet",
      price: "$29.90",
      url: "https://iangelface.com/products/year-of-the-horse-999-sterling-silver-string-braided-protection-bracelet",
      image: "https://cdn.shopify.com/s/files/1/0806/8225/4586/files/tuya_621e1f11-1cdd-49ea-9b07-53d46c402298.jpg?v=1767782806",
      tags: ["health", "energy"],
      cssClass: "p-health"
    }
  ];
}

// --- Interpretations Database ---
const interpretations = {
  wealth: {
    desc: "Your financial energy field is currently experiencing blockages. The cosmic currents show a significant outflow of wealth energy, indicating potential unexpected expenses or missed lucrative opportunities.",
    remedy: "To seal these energetic leaks, you must ground your financial aura. A Pixiu or Abundance talisman will act as a spiritual magnet to redirect positive wealth flow back to you."
  },
  health: {
    desc: "Your vital life force (Qi) is fluctuating heavily. You may experience unexplained fatigue, poor sleep, or minor ailments as your internal energy struggles to maintain equilibrium against external spiritual static.",
    remedy: "You require immediate energetic grounding. Obsidian or Sterling Silver close to your pulse points can help absorb negative static and restore your physical vitality."
  },
  love: {
    desc: "The Peach Blossom aura around you is unusually dim this month. This can lead to misunderstandings with loved ones, feelings of isolation, or attracting the wrong kind of romantic energy.",
    remedy: "Activate your heart chakra and attract harmonious connections by introducing White Jade or balancing crystals into your daily aura field."
  },
  career: {
    desc: "Stagnation is detected in your professional sector. You might face unrecognized efforts, office politics, or a general feeling of being stuck in your current trajectory.",
    remedy: "Break through this career ceiling by employing sacred geometry or Koi symbology to stimulate upward momentum and attract benevolent mentors."
  },
  energy: {
    desc: "Your overall magnetic field is compromised, leaving you vulnerable to 'Sha Qi' (negative energy). This manifests as bad luck, sudden obstacles, and a clouded intuition.",
    remedy: "A powerful spiritual shield is required. Wear protective amulets or Zodiac-aligned talismans to create a barrier against negativity and restore your natural luck."
  }
};

// --- App State ---
let userData = {
  birthday: '',
  gender: '',
  email: ''
};

let fortuneScores = {
  wealth: 0,
  health: 0,
  love: 0,
  career: 0,
  energy: 0
};

// --- Initialization ---
document.addEventListener('DOMContentLoaded', () => {
  initParticles();
  
  // Set max date for birthday input to today
  const today = new Date().toISOString().split('T')[0];
  document.getElementById('input-birthday').setAttribute('max', today);
  
  // Set current month in result
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const d = new Date();
  document.getElementById('result-month').textContent = `${months[d.getMonth()]} ${d.getFullYear()}`;
});

// --- Navigation ---
function showSection(id) {
  document.querySelectorAll('.section').forEach(sec => sec.classList.remove('active'));
  document.getElementById(id).classList.add('active');
}

function startReading() {
  showSection('form-section');
}

function goToStep(step) {
  // Validation
  if (step === 2) {
    const bd = document.getElementById('input-birthday').value;
    if (!bd) {
      alert("Please enter your birth date to continue.");
      return;
    }
    userData.birthday = bd;
  }
  if (step === 3) {
    const gender = document.querySelector('input[name="gender"]:checked');
    if (!gender) {
      alert("Please select your energy polarity (gender).");
      return;
    }
    userData.gender = gender.value;
  }

  // UI Update
  document.querySelectorAll('.form-step').forEach(el => el.classList.remove('active'));
  document.getElementById(`step-${step}`).classList.add('active');
  
  document.querySelectorAll('.step-dot').forEach(el => {
    const s = parseInt(el.getAttribute('data-step'));
    el.classList.remove('active', 'completed');
    if (s === step) el.classList.add('active');
    else if (s < step) el.classList.add('completed');
  });
  
  document.querySelectorAll('.step-line').forEach((el, index) => {
    if (index + 1 < step) el.classList.add('active');
    else el.classList.remove('active');
  });
}

function resetApp() {
  document.getElementById('input-birthday').value = '';
  const genderRadio = document.querySelector('input[name="gender"]:checked');
  if(genderRadio) genderRadio.checked = false;
  document.getElementById('input-email').value = '';
  showSection('hero-section');
  goToStep(1);
}

// --- Background Shopify Subscription ---
function submitToShopify(email) {
  // Basic email validation before sending
  if (!email || !email.includes('@')) return;
  
  const formData = new FormData();
  formData.append('form_type', 'customer');
  formData.append('utf8', '✓');
  // Add tags so you know they came from the Fortune Report app
  formData.append('contact[tags]', 'newsletter, fortune_report_app');
  formData.append('contact[email]', email);

  // Send the request in the background without reloading the page
  // This works natively when the page is embedded inside the Shopify domain
  fetch('/contact#contact_form', {
    method: 'POST',
    body: formData
  }).catch(err => {
    console.warn('Subscription background submission handled.', err);
  });
}

// --- Fortune Generation ---
function generateFortune() {
  userData.email = document.getElementById('input-email').value;
  
  // 触发后台发送邮件订阅请求到 Shopify
  submitToShopify(userData.email);

  showSection('loading-section');
  
  let progress = 0;
  const fill = document.getElementById('loading-fill');
  const texts = [
    "Aligning celestial energies...",
    "Calculating Bazi pillars...",
    "Scanning aura frequencies...",
    "Consulting the oracle..."
  ];
  const textEl = document.getElementById('loading-text');
  
  const interval = setInterval(() => {
    progress += Math.random() * 15;
    if (progress > 100) progress = 100;
    fill.style.width = `${progress}%`;
    
    if (progress < 25) textEl.textContent = texts[0];
    else if (progress < 50) textEl.textContent = texts[1];
    else if (progress < 75) textEl.textContent = texts[2];
    else textEl.textContent = texts[3];
    
    if (progress === 100) {
      clearInterval(interval);
      setTimeout(() => {
        calculateScores();
        renderResults();
        showSection('result-section');
      }, 500);
    }
  }, 300);
}

function calculateScores() {
  // Base seed on birthday to feel "personalized"
  let seed = 0;
  if (userData.birthday) {
    seed = userData.birthday.split('-').reduce((acc, val) => acc + parseInt(val), 0);
  }
  
  // Randomizer function seeded vaguely
  const randomScore = (min, max, offset) => {
    const val = Math.sin(seed + offset) * 10000;
    const rand = val - Math.floor(val);
    return Math.floor(rand * (max - min + 1)) + min;
  };

  // Requirement: "制造焦虑" (Create anxiety). We deliberately set 1-2 scores very low (20-40)
  // and keep average scores around 50-70.
  const aspects = ['wealth', 'health', 'love', 'career', 'energy'];
  
  aspects.forEach((a, i) => {
    fortuneScores[a] = randomScore(40, 85, i);
  });
  
  // Force a distinct weakness based on the seed to create anxiety
  const weaknessIndex = seed % 5;
  fortuneScores[aspects[weaknessIndex]] = randomScore(15, 35, 99);
  
  // Ensure gender has a slight impact just for flavor
  if (userData.gender === 'female') {
    fortuneScores.love = Math.min(95, fortuneScores.love + 5);
    fortuneScores.energy = Math.max(15, fortuneScores.energy - 5);
  } else {
    fortuneScores.career = Math.min(95, fortuneScores.career + 5);
    fortuneScores.health = Math.max(15, fortuneScores.health - 5);
  }
}

// --- Rendering ---
function renderResults() {
  // 1. Render Zodiac sign roughly
  const year = parseInt(userData.birthday.split('-')[0]);
  const zodiacs = ["Monkey", "Rooster", "Dog", "Pig", "Rat", "Ox", "Tiger", "Rabbit", "Dragon", "Snake", "Horse", "Goat"];
  if (!isNaN(year)) {
    const sign = zodiacs[year % 12];
    document.getElementById('result-zodiac').textContent = `Year of the ${sign} • ${userData.gender === 'female' ? 'Yin' : 'Yang'} Energy`;
  }

  // 2. Render Score Cards
  const cardsContainer = document.getElementById('score-cards');
  cardsContainer.innerHTML = '';
  
  const labels = {
    wealth: '财运 Wealth',
    health: '健康 Health',
    love: '爱情 Love',
    career: '事业 Career',
    energy: '磁场 Energy'
  };

  let totalScore = 0;
  let lowestScore = 100;
  let weakness = '';

  for (const [key, value] of Object.entries(fortuneScores)) {
    totalScore += value;
    if (value < lowestScore) {
      lowestScore = value;
      weakness = key;
    }
    
    let statusClass = 'good';
    if (value < 40) statusClass = 'danger';
    else if (value < 65) statusClass = 'warning';

    cardsContainer.innerHTML += `
      <div class="score-card ${statusClass}">
        <div class="score-label">${labels[key]}</div>
        <div class="score-value">${value}</div>
      </div>
    `;
  }

  // 3. Overall Score
  const avg = Math.round(totalScore / 5);
  document.getElementById('overall-value').textContent = avg;
  
  const ringFill = document.getElementById('overall-ring-fill');
  const circumference = 339.292; // 2 * PI * 54
  const offset = circumference - (avg / 100) * circumference;
  ringFill.style.strokeDashoffset = offset;

  const overallDesc = document.getElementById('overall-desc');
  if (avg < 50) overallDesc.innerHTML = "<span style='color:var(--danger-color)'>Critical Energy Depletion.</span> Immediate spiritual remedies recommended.";
  else if (avg < 70) overallDesc.innerHTML = "<span style='color:orange'>Unstable Frequencies.</span> Caution advised in major decisions this month.";
  else overallDesc.innerHTML = "<span style='color:var(--success-color)'>Harmonious Flow.</span> Maintain your energy to capitalize on opportunities.";

  // 4. Draw Radar Chart
  drawRadarChart();

  // 5. Reading & Remedies (Based on weakness to create anxiety)
  const readingHTML = `
    <p>The stars indicate an average overall baseline, but a significant vulnerability has been detected in your <strong>${weakness.toUpperCase()}</strong> sector.</p>
    <p>${interpretations[weakness].desc}</p>
    <p>If left unaddressed, this low vibration can seep into other areas of your life, causing a domino effect of misfortune.</p>
  `;
  document.getElementById('reading-content').innerHTML = readingHTML;

  const remediesHTML = `
    <div class="remedy-item">
      <h4>Action Required: Boost ${weakness.charAt(0).toUpperCase() + weakness.slice(1)}</h4>
      <p>${interpretations[weakness].remedy}</p>
    </div>
  `;
  document.getElementById('remedies-list').innerHTML = remediesHTML;

  // 6. Product Recommendations
  renderProducts(weakness);
}

function renderProducts(weakness) {
  const container = document.getElementById('products-grid');
  container.innerHTML = '';
  
  // Filter products by weakness tag, or fall back to general ones
  let recommended = products.filter(p => p.tags.includes(weakness));
  
  // If not enough, pad with wealth/protection
  if (recommended.length < 2) {
    const fillers = products.filter(p => !recommended.includes(p));
    recommended = recommended.concat(fillers).slice(0, 3);
  } else {
    // Just take top 3
    recommended = recommended.slice(0, 3);
  }

  recommended.forEach(p => {
    container.innerHTML += `
      <a href="${p.url}" target="_blank" class="product-card ${p.cssClass}">
        <div class="product-img">
          <img src="${p.image}" alt="${p.title}" class="product-real-img">
        </div>
        <div class="product-info">
          <div class="product-title">${p.title}</div>
          <div class="product-price">${p.price}</div>
          <div class="btn-buy">Claim Protection</div>
        </div>
      </a>
    `;
  });
}

// --- Radar Chart Drawing (HTML5 Canvas) ---
function drawRadarChart() {
  const canvas = document.getElementById('radar-chart');
  const ctx = canvas.getContext('2d');
  const cx = canvas.width / 2;
  const cy = canvas.height / 2;
  const radius = 140;
  
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  
  const labels = ['Wealth', 'Health', 'Love', 'Career', 'Energy'];
  const data = [
    fortuneScores.wealth,
    fortuneScores.health,
    fortuneScores.love,
    fortuneScores.career,
    fortuneScores.energy
  ];
  
  const sides = 5;
  const angleStep = (Math.PI * 2) / sides;
  
  // Draw background web
  ctx.lineWidth = 1;
  ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)';
  
  for (let level = 1; level <= 5; level++) {
    const r = (radius / 5) * level;
    ctx.beginPath();
    for (let i = 0; i <= sides; i++) {
      const angle = i * angleStep - Math.PI / 2;
      const x = cx + r * Math.cos(angle);
      const y = cy + r * Math.sin(angle);
      if (i === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    }
    ctx.stroke();
  }
  
  // Draw axes
  for (let i = 0; i < sides; i++) {
    const angle = i * angleStep - Math.PI / 2;
    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.lineTo(cx + radius * Math.cos(angle), cy + radius * Math.sin(angle));
    ctx.stroke();
    
    // Labels
    const labelX = cx + (radius + 25) * Math.cos(angle);
    const labelY = cy + (radius + 25) * Math.sin(angle);
    ctx.fillStyle = '#d4af37';
    ctx.font = '14px Inter';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(labels[i], labelX, labelY);
  }
  
  // Draw data polygon
  ctx.beginPath();
  for (let i = 0; i < sides; i++) {
    const value = data[i];
    const r = (radius * value) / 100;
    const angle = i * angleStep - Math.PI / 2;
    const x = cx + r * Math.cos(angle);
    const y = cy + r * Math.sin(angle);
    
    if (i === 0) ctx.moveTo(x, y);
    else ctx.lineTo(x, y);
  }
  ctx.closePath();
  
  // Fill & Stroke data
  ctx.fillStyle = 'rgba(212, 175, 55, 0.3)';
  ctx.fill();
  ctx.lineWidth = 2;
  ctx.strokeStyle = '#d4af37';
  ctx.stroke();
  
  // Draw points
  for (let i = 0; i < sides; i++) {
    const value = data[i];
    const r = (radius * value) / 100;
    const angle = i * angleStep - Math.PI / 2;
    const x = cx + r * Math.cos(angle);
    const y = cy + r * Math.sin(angle);
    
    ctx.beginPath();
    ctx.arc(x, y, 4, 0, Math.PI * 2);
    ctx.fillStyle = '#fff';
    ctx.fill();
    ctx.stroke();
  }
}

// --- Background Particles ---
function initParticles() {
  const canvas = document.getElementById('particles-canvas');
  const ctx = canvas.getContext('2d');
  let width, height;
  let particles = [];

  function resize() {
    width = canvas.width = window.innerWidth;
    height = canvas.height = window.innerHeight;
  }

  class Particle {
    constructor() {
      this.x = Math.random() * width;
      this.y = Math.random() * height;
      this.size = Math.random() * 2;
      this.speedX = Math.random() * 0.5 - 0.25;
      this.speedY = Math.random() * 0.5 - 0.25;
      this.opacity = Math.random() * 0.5;
    }
    update() {
      this.x += this.speedX;
      this.y += this.speedY;
      if (this.x < 0 || this.x > width) this.speedX *= -1;
      if (this.y < 0 || this.y > height) this.speedY *= -1;
    }
    draw() {
      ctx.fillStyle = `rgba(212, 175, 55, ${this.opacity})`;
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  function createParticles() {
    particles = [];
    const count = Math.floor(window.innerWidth / 10);
    for (let i = 0; i < count; i++) {
      particles.push(new Particle());
    }
  }

  function animate() {
    ctx.clearRect(0, 0, width, height);
    particles.forEach(p => {
      p.update();
      p.draw();
    });
    requestAnimationFrame(animate);
  }

  window.addEventListener('resize', () => {
    resize();
    createParticles();
  });

  resize();
  createParticles();
  animate();
}
